import { WORKSPACE_THEME } from "features/Dashboard/components/workspaceTheme"
import { DATAQ_THEME } from "theme/dataqTheme"

/**
 * The dashboards' antd tokens, so the tab spec's controls match the
 * platform. Links take the brand colour, as everywhere in the app, and
 * colorInfo takes info alerts, the progress bar and link hover to it
 * instead of antd's blue.
 */
export const TAB_SPEC_THEME = {
  ...WORKSPACE_THEME,
  token: {
    ...WORKSPACE_THEME.token,
    colorInfo: DATAQ_THEME.token?.colorPrimary,
  },
}
